(function () {
    'use strict';

    angular.module('swif.achats')
    .config(routeConfig)
    .service('ConsumableRequestService', ConsumableRequestService)
    .controller('ConsumableRequestsController', ConsumableRequestsController)
    .controller('ConsumableStockRequestController', ConsumableStockRequestController)
    .controller('ConsumableStockRequestActionsController', ConsumableStockRequestActionsController)
    .directive('consumableRequestLinesForm', consumableRequestLinesForm)
    .directive('panelConsumableRequest', panelConsumableRequest);

    function routeConfig ($routeProvider) {
        $routeProvider.when('/achats-stocks/consumable_requests/table_view', {
            templateUrl: 'partials/achats/consumable_requests_table_view.html',
            controller: 'ConsumableRequestsController',
            resolve: {
                data: ['ConsumableRequestService', function (service) {
                    return service.resolveData();
                }]
            },
            reloadOnSearch: false
        });
    }

    ConsumableRequestService.$inject = ['$q', 'swifFrameworkService', 'ConsumableStockService', 'AchatsService'];
    function ConsumableRequestService ($q, swif, stockSrv, achats) {
        var service = {};
        service.COLLECTION_FIELDS = [
            'id', 'swif_id', 'name', 'create_date', 'user_id', 'service_id', 'merge_line_ask_id', 'csv_merge_line_asks',
            'merge_line_asks', 'state', 'actions', 'shipped_rate', 'shipped_state', 'shipped',
            'note_cancel', 'task_id', 'task_swif_id', 'note', 'attachment_count', 'date_delivery'
        ];
        service.COLLECTION_ID = 'consumable_requests';
        service.getCollection = function () {
            return swif.collection.getCollection(service.COLLECTION_ID);
        };

        service.getCollectionFilter = function () {
            var user = swif.user.getAuthenticatedUserData();
            var is = achats.rights.getPermissions();
            var ret = {};
            if (!is.consumable_request.manager) {
                if (is.consumable_request.supervisor) {
                    var srv = user.service_ids || [];
                    swif.data.addExtraFilter(ret, 'collection', '|');
                    swif.data.addExtraFilter(ret, 'collection', 'service_id', '=', srv);
                } else if (is.consumable_request.claimer && user.service_id) {
                    swif.data.addExtraFilter(ret, 'collection', '|');
                    swif.data.addExtraFilter(ret, 'collection', 'service_id', '=', user.service_id[0]);
                }
                swif.data.addExtraFilter(ret, 'collection', 'user_id', '=', user.id);
            }
            return ret;
        };

        service.createCollection = function () {
            var filter = service.getCollectionFilter();
            filter.fields = service.COLLECTION_FIELDS;
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                service.COLLECTION_ID,
                'openstc_ask_prod',
                filter,
                {location: true}
            );
        };

        service.prepareAskForSave = function (model) {
            var m2o = achats.formatters.m2o;
            model.merge_line_ask_id = swif.data.prepareOne2manyValues(
                model.merge_line_ask_id || [],
                model.merge_line_asks,
                function (elt) {
                    return {
                        product_id: m2o(elt.product_id),
                        product_qty: elt.product_qty || 0,
                        service_id: m2o(model.service_id)
                    };
                }
            );
            return model;
        };

        service.preModal = function (data) {
            var ret = service.getCollection().preModal(data);
            if(data.action.id === 'add') {
                delete data.model.id;
                data.model._type = 'openstc_ask_prod';
                data.model.lines = [];
            } else if (data.action.id === 'ship') {
                data.model.cache = {};
                data.model.move_type = 'out';
                data.model.ask_prod_id = [data.model.id, data.model.name || ''];
                data.model.moves = [];
                _.forEach(data.model.merge_line_asks, function (ask) {
                    if (ask.qty_remaining > 0.0) {
                        var move = angular.copy(ask);
                        move.product_qty = move.qty_remaining;
                        delete move.id;
                        data.model.moves.push(move);
                    }
                });
                stockSrv.parseNewMoves(data.model);
            }
            return ret;
        };

        service.preValidate = function (data) {
            function onSuccess () {
                return true;
            }
            function wkf (model, signal) {
                return swif.data.execWorkflow('openstc_ask_prod', model.id, signal);
            }
            var ret;
            switch (data.action.id)  {
                case 'add':
                    service.prepareAskForSave(data.model);
                    ret = swif.data.create('openstc_ask_prod', data.model);
                    break;
                case 'edit':
                    service.prepareAskForSave(data.model);
                    ret = swif.data.save('openstc_ask_prod', data.model.id, data.model);
                    break;
                case 'confirm':
                    ret = swif.data.callKw(
                        'openstc_ask_prod',
                        'confirm_and_send_mail',
                        [data.model.id],
                        {
                            msg: data.model.msg || '',
                            user_ids: data.model.user_ids || [],
                            user_cc_ids: data.model.user_cc_ids || []
                        }
                    );
                    break;
                case 'ship':
                    ret = stockSrv.saveMoves(data.model);
                    break;
                case 'cancel':
                    ret = swif.data.save(
                        'openstc_ask_prod',
                        data.model.id,
                        {note_cancel: data.model.note_cancel}
                    ).then(function () {
                        return wkf(data.model, 'in_except');
                    });
                    break;
                case 'reopen':
                    service.prepareAskForSave(data.model);
                    ret = swif.data.save('openstc_ask_prod', data.model.id, data.model)
                    .then(function () {
                        return wkf(data.model, 'reopen');
                    });
                    break;
                default:
                    ret = service.getCollection().preValidate(data);
            }
            return ret;
        };

        service.callback = function (error, data) {
            if (data.action.id === 'add') {
                // TODO: could not use fasterCallback (for now),
                // data.result is not defiend here (perharps because modal.http is not defined)
                service.getCollection().getItems();
                achats.product.emptyConsumablesCart();
                swif.collection.defaultCallbackMessage(error, data);
            }
            else if (_.contains(swif.collection.defaultActionIds, data.action.id)) {
                service.getCollection().fasterCallback(data);
            } else if (_.contains([], data.action.id)) {
                service.getCollection().getItems();
            }
            else {
                service.getCollection().updateItem(data.model);
            }
        };

        service.getCountFilter = function ()  {
            var ret = {
                info: {},
                success: {}
            };
            swif.data.addFilter(ret.info, 'state', 'in', ['confirmed']);
            swif.data.addFilter(ret.success, 'state', 'in', ['in_progress']);
            return ret;
        };

        service.resolveData = function () {
            var ret = $q.defer();
            swif.route.check().then(function () {
                var defers = [];
                defers.push(service.createCollection());
                $q.all(defers).then(function (res) {
                    var data = {consumable_requests: res[0]};
                    ret.resolve(data);
                });
            });
            return ret.promise;
        };
        return service;
    }

    ConsumableRequestsController.$inject = ['$scope', 'swifFrameworkService', 'ConsumableRequestService', 'AchatsService', 'data', 'gettextCatalog'];
    function ConsumableRequestsController ($scope, swif, service, achats, data, gettextCatalog) {
        console.log('Init ConsumableRequestsController');
        $scope.consumable_requests = data.consumable_requests;
        $scope.preModal = service.preModal;
        $scope.preValidate = service.preValidate;
        $scope.callback = service.callback;
        $scope.countFilter = service.getCountFilter();
        $scope.translate = {
            'done': gettextCatalog.getString('Done'),
            'pending': gettextCatalog.getString('Pending'),
            'notStarted': gettextCatalog.getString('Not started')
        };

        function _doAction(request, action) {
                if (action) {
                    var options = {
                        preModal: $scope.preModal,
                        preValidate: $scope.preValidate,
                        callback: $scope.callback
                    };
                    swif.action.dispatch('openstc_ask_prod', action, request, options);
                }
            }

        var laction = achats.product.parseLocationForAction();
        if (laction .actionId) {
            var action = swif.action.getActionById(
                'openstc_ask_prod',
                laction.category,
                laction.actionId,
                {}
            );
            _doAction({}, action);
        }
    }

    ConsumableStockRequestController.$inject = ['$scope', 'swifFrameworkService', 'ConsumableStockService', 'AchatsService'];
    function ConsumableStockRequestController ($scope, swif, service, achats) {

        function getFilters (model) {
            var ret = {
                user: {}
            };
            swif.data.addFilter(ret.user, 'service_id', '=',  model.service_id ? model.service_id[0]: 0);
            return ret;
        };

        function initialize () {
            $scope.is = achats.rights.getPermissions();
            if (!$scope.model.merge_line_asks) {
                $scope.model.merge_line_asks = [];
            }
            var user = swif.user.getAuthenticatedUserData();
            if (!$scope.model.id) {
                $scope.model.service_id = user.service_id;
                $scope.model.user_id = [user.id, user.complete_name || user.name];
            }
            $scope.filters = {
                user: {}
            };
            var user_id = $scope.model.user_id;
            var srv = $scope.model.service_id;
            swif.data.addFilter($scope.filters.user, '|');
            swif.data.addFilter($scope.filters.user, 'id', '=', user_id ? user_id[0]: 0);
            swif.data.addFilter($scope.filters.user, 'service_id', '=', srv ? srv[0]: 0);

            if (user_id) {
                $scope.is_claimer = user_id[0] === swif.user.getAuthenticatedUserData().id;
            } else {
                $scope.is_claimer = true;
            }        }
        initialize();

        $scope.onChangeClaimer = function () {
            $scope.filters = getFilters($scope.model);
        };
        $scope.onChangeDepartment = function () {
            $scope.filters = getFilters($scope.model);
        };
    }

    ConsumableStockRequestActionsController.$inject = ['$scope', 'swifFrameworkService'];
    function ConsumableStockRequestActionsController ($scope, swif) {
        $scope.user = swif.user.getAuthenticatedUserData();
        if ($scope.model.user_id) {
            $scope.model.user_ids = [$scope.model.user_id[0]];
        }
        $scope.filters = {users: {}};

    }


    consumableRequestLinesForm.$inject = ['swifFrameworkService', '$sce', 'ConsumableStockService', 'AchatsService'];
    function consumableRequestLinesForm (swif, $sce, stockSrv, achatsSrv) {
        return {
            require: 'ngModel',
            restrict: 'E',
            scope: {
                readOnly: '=?',  // default: false
                useCart: '=?'  // default: true
            },
            link: function (scope, element, attr, ngModel) {

                scope.formatName = achatsSrv.formatName;

                function initialize () {
                    if (_.isUndefined(scope.useCart)) {
                        scope.useCart = true;
                    }
                    if (_.isUndefined(scope.readOnly)) {
                        scope.readOnly = false;
                    }
                    scope.is = achatsSrv.rights.getPermissions();
                    scope.model = {};
                    scope.model.cache = {};
                    // used to ensure only on initializeFromConsumables() is called at a time
                    // (some screens re-assign the ngModel twice a time, resulting in double data)
                    scope.initializing = false;
                    scope.filters = stockSrv.getFilters({});
                    scope.filters.consumable.fields = ['id', 'swif_id', 'name', 'product_id', 'complete_name', 'is_stock'];
                    scope.fakes = {
                        product_id: false
                    };
                    ngModel.$render = function () {
                        scope.model.moves = ngModel.$viewValue;
                        // for existing data, parse them
                        if (!_.isEmpty(scope.model.moves)) {
                            stockSrv.parseNewMoves(scope.model);
                        }
                        // if needed, update moves using consumables cart
                        if (!scope.initializing && scope.useCart) {
                            scope.initializing = true;
                            stockSrv.initializeFromConsumables(scope.model)
                            .then(function () {
                                scope.initializing = false;
                            });
                        }
                    };
                }
                initialize();

                scope.sync = function () {
                    ngModel.$setViewValue(scope.model.moves);
                };

                scope.onChangeFakeProduct = function (consumable) {
                    /*
                    Shitty code: it concerns consumables but it works with products...
                    As we want to filter "consumables" on the selected service,
                    we get them, then, we finnaly get the associated product via its product_id
                    and pass it to the list...
                    */
                    var filter = angular.copy(scope.filters.product_id);
                    swif.data.addFilter(filter, 'id', '=', consumable.product_id[0]);
                    swif.data.get('product', undefined, filter).then(product => {
                        var product = product[0];
                        if (product.id) {
                            var found = _.find(scope.model.moves, function (elt) {
                                return product.id === elt.product_id[0];
                            });
                            if (found) {
                                found.product_qty += 1.0;
                            } else {
                                var newItem = stockSrv.prepareMoveFromProduct(product, scope.model);
                                stockSrv.addMove(scope.model, newItem);
                            }
                            scope.fakes.product_id = false;
                            scope.sync();
                        }
                    })
                };
                scope.onRemoveLine = function (move) {
                    stockSrv.removeMove(scope.model, move);
                    scope.sync();
                };
            },
            templateUrl: 'partials/achats/consumable_request_form_directive.html'
        };
    }

    panelConsumableRequest.$inject = ['swifFrameworkService'];
    function panelConsumableRequest (swif) {
        var directive = swif.panel.create_directive('purchase_order_ask');
        directive.templateUrl = 'partials/achats/panel_consumable_request.html';
        return directive;
    }

})();
